import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DaDrawLogoAndText from '@wix/da-ds/pkg/DaDrawLogoAndText';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import {
  usePushMiniMuroModal,
  usePushMiniMobileMuroModal,
} from '../../../../utils/hooks/usePushMuroModal';
import { BiData, BiContextProvidedValue, EditWithMuroBiEvent } from '@wix/da-bi/pkg/events';
import CreatedWithBanner from '../CreatedWithBanner';

import s from './CreatedWithMuroDrawBanner.scss';

interface Props {}

const CreatedWithMuroDrawBanner: React.FC<Props> = () => {
  const { t } = useTranslation();
  const isDesktop = !useContext(MobileContext);
  const { restrictToLoggedIn } = useRestrictToLoggedIn();
  const pushMiniMuroModal = usePushMiniMuroModal();
  const pushMobileMiniMuroModal = usePushMiniMobileMuroModal();

  const titleText = isDesktop ? t('deviation.details.createdWith.draw.title') : '';
  return (
    <CreatedWithBanner
      logo={<DaDrawLogoAndText className={s['logo']} />}
      titleText={titleText}
      ctaText={t('deviation.details.createdWith.draw.link.text')}
      linkOnClick={restrictToLoggedIn(
        ReferralType.DRAW,
        isDesktop ? pushMiniMuroModal : pushMobileMiniMuroModal
      )}
      linkBiData={BiData<EditWithMuroBiEvent>({
        evid: 926,
        page_typeid: BiContextProvidedValue,
        page_itemid: BiContextProvidedValue,
        sectionname: 'created_with_banner',
      })}
      createdWithPrefix
    />
  );
};
CreatedWithMuroDrawBanner.displayName = 'CreatedWithMuroDrawBanner';

export default CreatedWithMuroDrawBanner;
